import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';
import { CandidateService } from 'src/app/_services/candidate.service';
import { GlobalService } from 'src/app/_services/global.service';
import * as _ from "underscore";


@Component({
  selector: 'app-hire-tags',
  imports: [MatAutocompleteModule, ReactiveFormsModule, NgbAlertModule, CommonModule],
  templateUrl: './hire-tags.component.html',
  styleUrl: './hire-tags.component.scss',
})
export class HireTagsComponent {
  tagText: FormControl = new FormControl('');
  tagErrorMessage: string = '';
  tags: any[] = [];
  tagTextValue: string = '';
  tagArray: any[] = [];
  tagchips: any[] = [];
  updatedTags: any[] = [];
  @ViewChild(MatAutocompleteTrigger) autocomplete: MatAutocompleteTrigger;
  tagid: string;
  @Input() candidateid: any;
  addTagSpinner: boolean = false;
  tagmessage: string = '';
  successMessage: string = '';
  errorMessage: string = '';
  payloadtagarray: any[] = [];
  tagList: any[] = [];
@ViewChild(MatAutocompleteTrigger)
trigger!: MatAutocompleteTrigger;
@ViewChild('dropdownRef', { static: true }) dropdownRef!: ElementRef;
closeAddTagDropdown: boolean = false;
disabledsBtn:boolean=false;
@Input() calledFrom: string ;

  constructor(private candidateservice: CandidateService) { }

  ngOnInit() {
    this.gettags();
  }

// ngAfterViewInit() {
//   const el = this.dropdownRef.nativeElement;
//   el.addEventListener('hide.bs.dropdown', (e: any) => {
//     if (this.keepDropdownOpen) {
//       e.preventDefault(); // 🔥 stop closing
//     }
//   });
// }
  searchTags(event) {
    this.tagErrorMessage = '';
    if (GlobalService.hasHTMLTags(event)) {
      this.tagErrorMessage = 'HTML tags are not allowed.';
      this.tags = [];
      return;
    }

    let data = event.replace(/'/g, "''");
    this.candidateservice.gettypedtags(data).subscribe((res: any) => {
      this.tags = res.message;
    })
  }

  createTag(tagdata) {
    this.tagErrorMessage = '';
    if (this.tagText.value != null && this.tagText.value != '') {
      if (GlobalService.hasHTMLTags(this.tagText.value)) {
        this.tagErrorMessage = 'HTML tags are not allowed.';
        this.tags = [];
        return;
      }
      let payload = {
        tagtext: this.tagText.value.replace(/'/g, "''")
      }
      const newtagtext = this.tags.filter(x => x.tagtext.toLowerCase().trim() == this.tagText.value.toLowerCase().trim())
   //   this.tagchips = [];
      if (newtagtext.length > 0) {
        const tagid = this.tagArray.filter(x => x.tagid == newtagtext[0].tagid)
        if (tagid.length > 0) {
          this.tagText.setValue('')
          this.autocomplete.closePanel()
        } else {
          this.tagArray.push({ action: 'create', tagtext: newtagtext[0].tagtext, tagid: newtagtext[0].tagid, candidatenumber: this.candidateid })
          this.tagchips.push({ action: 'create', tagtext: newtagtext[0].tagtext, tagid: newtagtext[0].tagid, candidatenumber: this.candidateid })
          this.updatedTags.push({ action: 'create', tagtext: newtagtext[0].tagtext, tagid: newtagtext[0].tagid, candidatenumber: this.candidateid });
          this.tagText.setValue('')
          this.autocomplete.closePanel()
        }
      } else {
        this.candidateservice.createupdatetags(payload).subscribe((res: any) => {
          if (res.status == "success") {
            this.tagid = res.tagid
            this.tagArray.push({ action: 'create', tagtext: this.tagText.value, tagid: this.tagid, candidatenumber: this.candidateid })
            this.tagchips.push({ action: 'create', tagtext: this.tagText.value, tagid: this.tagid, candidatenumber: this.candidateid })
            this.updatedTags.push({ action: 'create', tagtext: this.tagText.value, tagid: this.tagid, candidatenumber: this.candidateid });



            this.tagText.setValue('')
          }
        })
      }


    }
  }

  doneFunction() {
    this.closeAddTagDropdown=true;
    if ((this.tagText.value == null || this.tagText.value == '' || this.tagText.value.trim() == '') && !this.updatedTags.length) {
      this.tagErrorMessage = 'Tag cannot be empty. Please provide a valid tag.';
      return;
    }

    if (GlobalService.hasHTMLTags(this.tagText.value)) {
      this.tagErrorMessage = 'HTML tags are not allowed.';
      this.tags = [];
      return;
    }

    let payloadtagarray = [];
    this.tagmessage = '';
    if (this.tagText.value != null && this.tagText.value != '') {
      let payload = {
        tagtext: this.tagText.value.replace(/'/g, "''")
      }
      const newtagtext = this.tags.filter(x => x.tagtext.toLowerCase().trim() == this.tagText.value.toLowerCase().trim())
      if (newtagtext.length > 0) {
        const tagid = this.tagArray.filter(x => x.tagid == newtagtext[0].tagid)
        if (tagid.length > 0) {
          this.tagText.setValue('')
          this.autocomplete.closePanel()
        } else {
          this.tagArray.push({ action: 'create', tagtext: newtagtext[0].tagtext, tagid: newtagtext[0].tagid, candidatenumber: this.candidateid })
          this.tagchips.push({ action: 'create', tagtext: newtagtext[0].tagtext, tagid: newtagtext[0].tagid, candidatenumber: this.candidateid })
          this.updatedTags.push({ action: 'create', tagtext: newtagtext[0].tagtext, tagid: newtagtext[0].tagid, candidatenumber: this.candidateid });
          this.tagText.setValue('')
          this.autocomplete.closePanel()
        }
      } else {
        this.addTagSpinner = true;
        this.candidateservice.createupdatetags(payload).subscribe((res: any) => {
          if (res.status == "success") {
            this.tagid = res.tagid

            this.tagArray.push({ action: 'create', tagtext: this.tagText.value, tagid: this.tagid, candidatenumber: this.candidateid })
            this.tagchips.push({ action: 'create', tagtext: this.tagText.value, tagid: this.tagid, candidatenumber: this.candidateid })
            this.updatedTags.push({ action: 'create', tagtext: this.tagText.value, tagid: this.tagid, candidatenumber: this.candidateid })




            this.tagText.setValue('')
          } else {
            this.addTagSpinner = false;
            this.tagmessage = res.message;
          }
        }, (error) => { this.addTagSpinner = false }, () => {
          this.addTagSpinner = false;
        })

      }
    } else {
      if (this.updatedTags.length) {
        const payload = {
          tags: this.updatedTags.map(x => (_.omit(x, 'tagtext')))
        }
        this.addTagSpinner = true;
        this.candidateservice.updatetags(payload).subscribe((res: any) => {
          if (res.status == "success") {
            this.gettags();
            this.successMessage = 'Tags updated successfully.';
            this.closeAddTagDropdown=false;

            setTimeout(() => this.successMessage = '', 5000);
          } else {
            this.errorMessage = res.message;
            setTimeout(() => this.errorMessage = '', 5000);
          }
          this.addTagSpinner = false;
        })

      }
    }

  }

  addTag(data:any, event: any) {
    this.closeAddTagDropdown=true
    this.disabledsBtn=true
      if (event.isUserInput) {
    this.tagErrorMessage = '';

    const tagid = this.tagArray.filter(x => x.tagid == data.tagid)[0]
    if (!tagid) {
      this.tagArray.push({ action: 'create', tagtext: data.tagtext, tagid: data.tagid, candidatenumber: this.candidateid })
      this.tagchips.push({ action: 'create', tagtext: data.tagtext, tagid: data.tagid, candidatenumber: this.candidateid })
      this.updatedTags.push({ action: 'create', tagtext: data.tagtext, tagid: data.tagid, candidatenumber: this.candidateid });

    }
     // 🔥 Keep autocomplete open
    setTimeout(() => {
      this.trigger.closePanel();
    });
  }
  }

  unselect(tagid, type?) {
    this.disabledsBtn=true
    this.tagErrorMessage = '';
    this.tagArray = _.reject(this.tagArray, { tagid: tagid })
    this.tagchips = _.reject(this.tagchips, { tagid: tagid })
    this.updatedTags.push({ action: 'archive', tagid: tagid, candidatenumber: this.candidateid });
    this.payloadtagarray.push({ action: 'archive', tagid: tagid, candidatenumber: this.candidateid });
    if(type == 'deletetag') this.doneFunction();
  }

    gettags() {
      this.updatedTags = [];
      this.candidateservice.gettags(this.candidateid).subscribe((res:any)=>{
        this.tagList = res.candidatetags
        this.tagchips = [];
        this.tagList.map(x=>{

            this.tagArray.push({action: 'update', tagid: x.tagid, tagtext: x.tagtext, candidatenumber: this.candidateid})
            this.tagchips.push({action: 'update', tagid: x.tagid, tagtext: x.tagtext, candidatenumber: this.candidateid})


          })
      })
    }
toggleAddTagDropdown(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.closeAddTagDropdown = !this.closeAddTagDropdown;
  }
    closeAddTagModal(){
      this.closeAddTagDropdown = false;
    }
}
